import { render } from "./FeatureForm.vue?vue&type=template&id=43afe2a6"
import script from "./FeatureForm.vue?vue&type=script&lang=js"
export * from "./FeatureForm.vue?vue&type=script&lang=js"

import "./FeatureForm.vue?vue&type=style&index=0&id=43afe2a6&lang=css"

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__